@if (category; as c) {
  @let firstItem = c.items[0];

  <div class="row rounded-2 bg-card mt-2">
    <div class="col text-center">
      <span class="fs-lg p-1 text-body-emphasis">{{ c.title }}</span>
      @if (icon) {
        <i class="{{ icon }}" [ngStyle]="{ transform: 'rotate(' + bearing + 'deg)' }"></i>
      }
    </div>
  </div>
  <div class="row mt-2">
    <!-- Special case for condition category. TODO Resolve in the future -->
    @if (c.title !== 'Conditions') {
      <div class="col-12 col-sm-4 gy-1 text-center">
        <span class="fs-xl text-truncate text-lightgray"
          >{{ firstItem?.value }}{{ firstItem?.value ? firstItem?.unit : '' }}</span
        >
      </div>
    }
    @if (c.title === 'Conditions') {
      <div class="col-6 col-sm-4 gy-2 text-center">
        <div class="row text-center">
          <span class="fs-xs text-lightgray"
            >{{ firstItem?.value }}{{ firstItem?.value ? firstItem?.unit : '' }}</span
          >
        </div>
        <div class="row text-center">
          <span class="fs-2xs">{{ firstItem?.description }}</span>
        </div>
      </div>
    }

    <app-details-item
      class="col-6 col-sm-4 gy-2 text-center"
      [description]="c.items[1]?.description"
      [value]="c.items[1]?.value"
      [unit]="c.items[1]?.unit"
    ></app-details-item>
    <app-details-item
      class="col-6 col-sm-4 gy-2 text-center"
      [description]="c.items[2]?.description"
      [value]="c.items[2]?.value"
      [unit]="c.items[2]?.unit"
    ></app-details-item>
  </div>
}
